import { useBusiness } from '../contexts/BusinessContext';

export function useBusinessId() {
  const { selectedBusiness } = useBusiness();
  return selectedBusiness?.id;
} 